import { createFileRoute } from "@tanstack/react-router";

import { isParent, type Parent } from "@components/breadcrumbs/parentRoutes.ts";
import { RequireCapability } from "@components/RequireCapability.tsx";
import { MACHINE_READ } from "@/AccessPermissions.ts";
import { MachineDetail } from "@/features/machine/components/MachineDetail.tsx";

export const Route = createFileRoute("/machines/$machineId")({
  validateSearch: (search: Record<string, unknown>): { from?: Parent } => ({
    from: isParent(search.from) ? search.from : undefined
  }),
  component: () => (
    <RequireCapability all={[MACHINE_READ]}>
      <MachineDetail />
    </RequireCapability>
  ),
  staticData: { breadcrumb: "machine.title" }
});
